// chatbotReducer.js
  import { TOGGLE_CHATBOT, SHOW_CHATBOT, HIDE_CHATBOT } from '../actions/chatbotActions';

const initialState = {
  visible: false,
  loading: false,
  error: null,
  messages: [],
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CHATBOT:
      console.log("TOGGLE_CHATBOT", state.visible);
      return { ...state, visible: !state.visible };
    case SHOW_CHATBOT:
      return { ...state, visible: true };
    case HIDE_CHATBOT:
      return { ...state, visible: false };
    case 'CHATBOT_MESSAGE_SEND_START':
      return { ...state, loading: true, error: null };
    case 'CHATBOT_MESSAGE_SEND_SUCCESS':
      return {
        ...state,
        loading: false,
        // messages: [...(state.messages || []), { type: 'bot', text: action.payload }],
            };
    case 'CHATBOT_MESSAGE_SEND_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case "CHATBOT_MESSAGE_PARTIAL":
      return {
        ...state,
        messages: state.messages.map((m, i, arr) =>
          i === arr.length - 1 && m.type === "bot"
            ? { ...m, text: m.text + action.payload } // append chunk
            : m
        ),
      };

    case "CHATBOT_MESSAGE_SEND_START_BOT":
      return {
        ...state,
        messages: [...state.messages, { type: "bot", text: "" }],
      };


  case 'CHATBOT_MESSAGE_SEND_USER':
  return {
    ...state,
    messages: [...state.messages, { type: 'user', text: action.payload }],
  };
    default:
      return state;
  }
}

export default chatbotReducer;